// extracted by mini-css-extract-plugin
export default {"copy-to-clipboard-button":"style_copy-to-clipboard-button__Svw1O"};